<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <div class="ion-no-padding mb-1">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Route Details</ion-title>
    </div>

    <div class="d-flex  mb-3 justify-content-between ion-padding-horizontal align-items-center">
      <div class="d-flex ">
        <div class="radio-container ms-0">
          <input id="dayPlannerForm" class="radio-btn" name="route-radio" [checked]="radioValue === ROUTE_CRAFT_TYPES.DAY_PLANNER" type="radio" (click)="changeRadioValue(ROUTE_CRAFT_TYPES.DAY_PLANNER)">
          <label for="dayPlannerForm" class="radio-label">Day Planner</label>
        </div>

        <div class="radio-container ">
          <input id="freeTextForm" class="radio-btn" name="route-radio" [checked]="radioValue === ROUTE_CRAFT_TYPES.FREE_TEXT" type="radio" (click)="changeRadioValue(ROUTE_CRAFT_TYPES.FREE_TEXT)">
          <label for="freeTextForm" class="radio-label">Free Text</label>
        </div>
      </div>

      <div>
        <div class="d-flex" *ngIf="radioValue === ROUTE_CRAFT_TYPES.DAY_PLANNER">
          <ion-button *ngIf="!hideAiSection" (click)="generateAiRouteAndPatch()" class="filled-blue-btn">Generate With AI</ion-button>
          <ion-button class="unfilled-red-btn" (click)="clearAllRouteFormData()">Clear</ion-button>
        </div>
      </div>
    </div>

    <!-- Day planner main container start -->
    <form [formGroup]="routeCraftForm" *ngIf="radioValue === ROUTE_CRAFT_TYPES.DAY_PLANNER">
      <div class="form-container ion-padding-horizontal">
        <!-- Free text main container start -->
        <div formArrayName="days">
          <div *ngFor="let day of freeTextDays.controls; index as i" [formGroupName]="i"
            class="free-text-main-container">
            <div class="row gap-1">
              <div class="col-2 pe-0">
                <p class="day-title">Day {{i+1}}*</p>
              </div>
              <div class="col ps-0">
                <div class="input-container">
                  <div [ngClass]="{ 'invalid-input': day.get('day')?.invalid && day.get('day')?.touched }">
                    <input type="text" class="input input-text route-title" formControlName="day" placeholder="Title for the day">
                  </div>
                </div>
              </div>
            </div>

            <div class="row gap-1">
              <div class="col-2 pe-0">
                <div class="input-container">
                  <label for="" class="label">Meals</label>
                  <div>
                    <app-meal-plan-input [flexColumn]="true" [items]="meals" [selectAllKey]="MEAL_PLAN.ALL_INCLUSION" formControlName="mealPlan"></app-meal-plan-input>
                  </div>
                </div>
              </div>
              <div class="col ps-0">
                <div class="input-container">
                  <div
                    [ngClass]="{ 'invalid-input': day.get('activities')?.invalid && day.get('activities')?.touched }">
                    <app-text-formatting-input formControlName="activities"
                      [inputHeight]="'md'"></app-text-formatting-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- Day planner main container End -->

    <!-- Free text main container start -->
    <form [formGroup]="freeTextForm" *ngIf="radioValue === ROUTE_CRAFT_TYPES.FREE_TEXT">
      <div class="ion-padding-horizontal">
        <div class="row">
          <div class="col">
            <div class="input-container">
              <div [ngClass]="{ 'invalid-input': freeTextForm.get('text')?.invalid && freeTextForm.get('text')?.touched }">
                <app-text-formatting-input formControlName="text" [inputHeight]="'lg'"></app-text-formatting-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- Free text main container start -->

    <!-- section note -->
    <div class="ion-padding-horizontal">
      <div class="row">
        <div class="col">
          <div class="input-container">
            <label for="" class="label">Notes</label>
            <div>
              <app-text-formatting-input [(ngModel)]="sectionNote" (ngModelChange)="sectionNotesChanged()"></app-text-formatting-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="input-container">
            <label for="" class="label mb-0 align-middle" style="text-transform: none;"><input [(ngModel)]="acknowledgement" (ngModelChange)="acknowledgementChanged()" type="checkbox" name="" id="" class="align-middle"> I acknowledge that the above Route craft information is correct to the best of my knowledge.</label>
            <p class="mb-0"><span class="warning-message" *ngIf="!acknowledgement">Please check the acknowledgement to proceed</span></p>
          </div>
        </div>
      </div>
    </div>

  </div>


  <div class="ion-padding-horizontal bg-light-gray itinerary-model-footer justify-content-center">
    <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>

</div>